<template>
  <div>
    <vs-breadcrumb>
      <li>
        <a
          aria-current="page"
          style="color: var(--text-color-2)"
          title="Device Management"
          >Device Management</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Location</li>
    </vs-breadcrumb>
    <!-- <pre>{{link2dash}}</pre> -->
    <!-- <pre>{{this.selected }}</pre> -->
    <vs-row>
      <vs-card style="border-radius: 20px">
        <div class="mt-2">
          <vs-row id="center"> <h3 class="">Location</h3> </vs-row><br /><br />

          <b-container fluid>
            <!-- User Interface controls -->
            <b-row>
              <b-col lg="6" class="my-1">
                <b-form-group
                  label="Filter"
                  label-for="filter-input"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filter-input"
                      v-model="filter"
                      type="search"
                      placeholder="Type to Search"
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col lg="6" class="my-1">
                <b-form-group
                  v-model="sortDirection"
                  label="Filter On"
                  description="Leave all unchecked to filter on all data"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-checkbox-group
                    v-model="filterOn"
                    :aria-describedby="ariaDescribedby"
                    class="mt-1"
                  >
                    <b-form-checkbox value="branch_code">Code</b-form-checkbox>
                    <b-form-checkbox value="branch_name">Name</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>

            <br />
            <!-- Main table element -->
            <b-table
              :items="getDataLocation"
              :fields="fields"
              selectable
              :filter="filter"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              select-mode="single"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @row-selected="link2dash"
              stacked="md"
              show-empty
              small
              @filtered="onFiltered"
            >
              <template #head()="data">
                <span class="" style="color:var(--text-color)">{{ data.label.toUpperCase() }}</span>
              </template>
              <template #cell()="data">
                <span class="" style="color:var(--text-color-2)">{{ data.value }}</span>
              </template>
            </b-table>
          </b-container>
        </div>
      </vs-card>
    </vs-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    headerFilter: ["Code", "Name"],
    selectData: [],
    viewdata: "",
    searchHeader: "",
    selectFilterName: "",
    selectFilterCode: "",
    getDataLocation: [{
        branch_code: '00001',
        branch_name: "ธนารักษ์พัฒนาสินทรัพย์",
        username: "Bret",
        email: "Sincere@april.biz",
        website: "hildegard.org",
      },],
    users: [
      {
        id: 1,
        name: "Leanne Graham",
        username: "Bret",
        email: "Sincere@april.biz",
        website: "hildegard.org",
      },
      {
        id: 2,
        name: "Ervin Howell",
        username: "Antonette",
        email: "Shanna@melissa.tv",
        website: "anastasia.net",
      },
      {
        id: 3,
        name: "Clementine Bauch",
        username: "Samantha",
        email: "Nathan@yesenia.net",
        website: "ramiro.info",
      },
    ],
    selected: [],
    items: [
      {
        isActive: true,
        age: 40,
        name: { first: "Dickerson", last: "Macdonald" },
      },
      { isActive: false, age: 21, name: { first: "Larsen", last: "Shaw" } },
      {
        isActive: false,
        age: 9,
        name: { first: "Mini", last: "Navarro" },
        _rowVariant: "success",
      },
      { isActive: false, age: 89, name: { first: "Geneva", last: "Wilson" } },
      { isActive: true, age: 38, name: { first: "Jami", last: "Carney" } },
      { isActive: false, age: 27, name: { first: "Essie", last: "Dunlap" } },
      { isActive: true, age: 40, name: { first: "Thor", last: "Macdonald" } },
      {
        isActive: true,
        age: 87,
        name: { first: "Larsen", last: "Shaw" },
        _cellVariants: { age: "danger", isActive: "warning" },
      },
      { isActive: false, age: 26, name: { first: "Mitzi", last: "Navarro" } },
      {
        isActive: false,
        age: 22,
        name: { first: "Genevieve", last: "Wilson" },
      },
      { isActive: true, age: 38, name: { first: "John", last: "Carney" } },
      { isActive: false, age: 29, name: { first: "Dick", last: "Dunlap" } },
    ],
    selected: [],
    fields: [
      {
        key: "branch_code",
        label: "Code",
        sortable: true,
        sortDirection: "desc",
      },
      { key: "branch_name", label: "Name", sortable: true },
    ],
    totalRows: 1,
    currentPage: 1,
    perPage: 5,
    pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    filter: null,
    filterOn: [],
    infoModal: {
      id: "info-modal",
      title: "",
      content: "",
    },
  }),
  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    link2dash(item) {
      console.log(item.branch_code);
      this.$session.set("branch_code", item[0].branch_code);
      this.$session.set("data", item[0]);
      this.$router.push({
        path: "/dnetdashboard?" + item[0].branch_code,
        params: { data: item[0], branch_code: item[0].branch_code },
      });
      //  this.$router.push({
      //   name: "SensorDashboard",
      //   params: {
      //     nwname: item,
      //   },
      // });
    },
    handleSelected(tr) {
      this.$vs.notify({
        title: `Selected ${tr.branch_name}`,
        text: `Email: ${tr.branch_name}`,
      });
    },
    remove(item) {
      this.searchHeader.splice(this.searchHeader.indexOf(item), 1);
      switch (item) {
        case "Name":
          this.selectFilterName = "";
          break;
        case "Type":
          this.selectFilterCode = "";
          break;
        default:
          console.log("Try looking up for a hint.");
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  created() {
    //  console.log("aaaaaaaaaaaaaaaaaaaaaaa");
    // this.$API.get("mc/location").then((result) => {
    //   console.log(result.data);
    //   this.getDataLocation = result.data;
    //   // console.log("aaaaaaaaaaaaaaaaaaaaaaa");
    // });
  },
  computed: {
    filteredList() {},
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
};
</script>

<style scoped>
#center {
  display: flex;
  align-items: center;
}
</style>